module.exports = __webpack_public_path__ + "img/client-user.40ea69d7.png";